/* eslint-disable global-require */
import "@components/loading/style/loading.less";

import { LoadingOutlined } from "@ant-design/icons";
import React, { FC } from "react";

/**
 * @description 加载中
 * */
const Loading: FC = () => {
  return (
    <div className="loading">
      <div className="inner-loading">
        <img src={require('@assets/loading.svg').default} alt="" />
      </div>
    </div>
  );
};

export default Loading;
